<template>
  <div ref="stickyHeader" class="sticky-title-row" :class="{ 'is-scrolled': isScrolled }">
    <v-breadcrumbs
      v-if="breadcrumbItems.length"
      class="pa-0 pt-8"
      large
      :items="[
        {
          text: 'Főoldal',
          to: { name: 'Home' },
        },
        ...breadcrumbItems,
      ]"
      divider="/"
    />

    <div class="py-4 d-flex align-center flex-wrap">
      <div class="py-1">
        <h2 class="font-weight-bold">{{ title }}</h2>
        <div v-if="subtitle">{{ subtitle }}</div>
      </div>

      <v-spacer />

      <div class="d-flex justify-end align-center flex-grow-1 flex-wrap py-1">
        <slot name="buttons" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: '',
    },

    subtitle: {
      type: String,
    },

    breadcrumbItems: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {
      isScrolled: false,
    };
  },

  mounted() {
    window.addEventListener('scroll', this.handleScroll);
  },

  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll);
  },

  methods: {
    handleScroll() {
      this.isScrolled = window.scrollY > 10;
    },
  },
};
</script>
